import Vue from "vue";

const state = {
	settings: {},
	isDonwloadingCompanySettings: false,
	skipStartingTasks: false,
	company: {},
	productsContent: {},
	supplierTierInfo: null,
	allTiersOptionsInfo: null,
	reasons: [],
	isLoadingReasons: true,
	selectedReason: null,
	reasonTypesOptions: [
		{
			id: 0,
			name: "All",
		},
		{
			id: 1,
			name: "Bookings",
		},
		{
			id: 2,
			name: "Events",
		},
	],
	paymentCancelTypeOptions: [
		{
			name: "Payout",
			id: 0,
		},
		{
			name: "Refund",
			id: 1,
		},
	],
	showSunriseSunset: null,
	customBusinessTypes: [],
	selectedCustomBusinessType: null,
	isDownloadingSupplierReport: false,
	plugins: [],
	selectedSubscription: null,
	subscriptionCards: [
		{
			title: 'Dynamic Pricing',
			codeName: 'DynamicPricingRevenue',
			isSubcriptionActive: false,
			isAvailable: true,
			iconClass: '',
			subTitle: 'Maximize revenue with strategic solutions',
			prices: [
				{
					value: 0.30,
					valueType: '%',
					priceType: 'fee added'
				}
			],
			subscriptionBtn: {
				name: 'Available',
				iconClass: 'fa-lock',
				tooltipInfo: {
					content: 'Please contact support to activate!',
					offset: '30px',
					classes: ['dark']
				},
			},
			suggestions: [],
			subscriptionDetails: {
				title: 'Specifications',
				info: [
					{ detail: 'Price changes automation' },
					{ detail: 'Sales channel optimization' },
					{ detail: 'Sales optimization' },
					{ detail: 'Price control by sales channel' },
					{ detail: 'Adapted Sales management' }
				]
			}
		},
		{
			title: 'Invoicing',
			codeName: 'InvoiceExpress',
			isSubcriptionActive: false,
			isAvailable: false,
			iconClass: '',
			subTitle: 'Smart invoicing solutions',
			prices: [
				{
					value: 20,
					valueType: '€',
					priceType: 'per month'
				},
			],
			subscriptionBtn: {
				name: 'Coming soon',
				iconClass: 'fa-lock',
				tooltipInfo: {
					content: 'Please contact support to activate!',
					offset: '30px',
					classes: ['dark']
				},
			},
			suggestions: [],
			subscriptionDetails: {
				title: 'Specifications',
				info: [
					{ detail: 'Easy integration with reservations system' },
					{ detail: 'Real-time invoiced reservations monitoring' },
					{ detail: 'Direct and centralized invoicing sales channels' },
					{ detail: 'Personalized billing rules creation (Agents)' },
					{ detail: 'Partial invoicing' }
				]
			}
		}
	]
};

const getters = {
	getSubscribedPlugins: (state) => state.plugins,
	getSelectedSubscription: (state) => state.selectedSubscription,
	getSubscriptionCards: (state) => state.subscriptionCards,
	getHasDynamicPricingRevenuePlugin: (state) => state.plugins.includes('DynamicPricingRevenue'),
	getCompanyInfo: (state) => state.company,
	getIsDonwloadingCompanySettings: (state) => state.isDonwloadingCompanySettings,
	getCompanySettings: (state) => state.settings,
	getSkipStartTasks: (state) => state.skipStartingTasks,
	getShowInvoiceOption: (state, rootState) => {
		return (
			state.settings.settingsPresets &&
			state.settings.settingsPresets.hasInvoiceSystem
		);
	},
	getHasInvoiceSystem: (state, getters) => {
		return getters.getShowInvoiceOption ? getters.getShowInvoiceOption : false;
	},
	getSupplierTierInfo: (state) => state.supplierTierInfo,
	getSupplierAllTiersOptionInfo: (state) => state.allTiersOptionsInfo,
	getIsLoadingReasons: (state) => state.isLoadingReasons,
	getSelectedReason: (state) => state.selectedReason,
	getReasonTypesOptions: (state) => state.reasonTypesOptions,
	getPaymentCancelTypeOptions: (state) => state.paymentCancelTypeOptions,
	getReasons: (state) => state.reasons || [],
	getReasonsAllBookings: (state) =>
		state.reasons.filter((reason) => reason.reasonType === 0 || reason.reasonType === 1),
	isFoundReasonsAllBookings: (state, getters) =>
		!!getters.getReasons && getters.getReasonsAllBookings.length > 0,
	getCustomBusinessTypes: (state) => state.customBusinessTypes,
	getSelectedCustomBusinessType: (state) => state.selectedCustomBusinessType,
	getIsDownloadingSupplierReport: (state) => state.isDownloadingSupplierReport,
	isFoundReasonsAllBookings: (state, getters) =>
		!!getters.getReasons && getters.getReasonsAllBookings.length > 0,
	getUserIntegrations: state => state.settings.integrations
};

const actions = {
	testEmail({}, payload) {
        return axios.post(`/api/Email/Test`, payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

	initCompany({ commit, rootState, dispatch }) {
		return dispatch("initSettings").then((initSettingsResponse) => {
			commit("GET_COMPANY_INFO", initSettingsResponse);

			return initSettingsResponse;
		});
	},

	initSettings({ state, commit, rootState, dispatch }) {
		state.isDonwloadingCompanySettings = true;

		dispatch("refreshAccountData").then((refreshAccountDataResponse) => {
			return axios
				.get("/api/supplier/GetSupplier", {
					params: {
						supplierid: rootState.user.account.supplierId,
					},
				})
				.then((getSupplierResponse) => {
					state.isDonwloadingCompanySettings = false;
					if (
						getSupplierResponse &&
						getSupplierResponse.status === 200 &&
						getSupplierResponse.data
					) {
						commit("UPDATE_SETTINGS_COMPANY", getSupplierResponse.data);
					}
				})
				.catch((err) => {
					state.isDonwloadingCompanySettings = false;
				});
		});
	},

	async downloadPersonalizedServices({ dispatch }) {
		dispatch("downloadSalesChannels");
	},

	donwloadSubscribedPlugins: ({ commit, rootState }) => {
		return axios
			.get("/api/plugin/subscribed", {
				params: {
					supplierId: rootState.user.account.supplierId,
				},
			})
			.then((response) => {
				if (response && response.status === 200) {
					commit("UPDATE_SUBSCRIBED_PLUGINS", response.data);
				}

				return response;
			})
			.catch((err) => {
				return err;
			});
	},

	enablePlugin: ({ commit }, data) => {
		return axios
			.put(`/api/plugin/enable?plugin=${data}`)
			.then((response) => {
				if (response && response.status === 200) {
					return response;
				}
			})
			.catch((err) => {
				return err;
			});
	},

	disablePlugin: ({ commit }, data) => {
		return axios
			.put(`/api/plugin/disable?plugin=${data}`)
			.then((response) => {
				if (response && response.status === 200) {
					return response;
				}
			})
			.catch((err) => {
				return err;
			});
	},

	setCardSubscription: ({ commit }, data) => {
		commit("SET_CARD_SUBSCRIPTION", data);
	},

	clearCardSubscription: ({ commit }) => {
		commit("CLEAR_CARD_SUBSCRIPTION");
	},

	saveSettingsCompany({ rootState, dispatch }, data) {
		let dataToSend = { agentId: 0, by: "", supplier: data };

		axios
			.post("/api/supplier/editsupplier", dataToSend)
			.then((response) => {
				if (response && response.status === 200) {
					Vue.toasted.success("Settings Saved");
					// update top dropdown with the new comapny name
					rootState.user.account.supplier.brand = data.brand;
					// dispatch("updateCompany", data);
				}
			})
			.catch(function () {
				Vue.tosted.error("error");
			});
	},

	saveSettingsPresets({ state, rootState }, data) {
		return axios
			.post("/api/supplier/SetPresets", {
				supplierid: rootState.user.account.supplierId,
				presets: data,
			})
			.then((response) => {
				if (response && response.status === 200) {
					Vue.toasted.success("Settings Saved");
					//update top dropdown with the new comapny name
				}
			})
			.catch(function () {
				Vue.tosted.error("error");
			});
	},

	updateCompany: ({ commit }, newCompany) => {
		commit("UPDATE_COMPANY", newCompany);
	},

	skipStartingTasks: ({ commit }) => {
		commit("SET_SKIP_STARTING_TASKS");
	},

	downloadSupplierTierSummary: ({ commit, rootState, state }) => {
		return axios
			.get("/api/subscription/GetSupplierTierInformation", {
				params: {
					supplierId: rootState.user.account.supplierId,
				},
			})
			.then((response) => {
				if (response && response.status === 200) {
					commit("SET_SUPPLIER_TIER", response.data);
				}
				return response;
			})
			.catch((err) => {
				return err;
			});
	},

	downloadTierOptions: ({ commit, rootState }) => {
		return axios
			.get("/api/subscription/gettiers")
			.then((response) => {
				if (response && response.status == 200) {
					commit("SET_ALL_TIERS_OPTIONS", response.data);
				}
				return response;
			})
			.catch((err) => {
				return err;
			});
	},

	async initReasons({ commit, rootState, state, dispatch }) {
		try {
			commit("SET_IS_LOADING_REASONS", true);
			let response = await axios.get("/api/supplier/GetReasons", {
				params: { supplierId: rootState.user.account.supplierId },
			});

			if (response && response.status === 200 && response.data) {
				commit("INIT_REASONS", {
					reasons: !!response.data ? response.data : [],
				});

				commit("SET_IS_LOADING_REASONS", false);
				return true;
			}

			commit("SET_IS_LOADING_REASONS", false);
			return false;
		} catch (error) {
			//Vue.toasted.error(error);
			commit("SET_IS_LOADING_REASONS", false);
		}
	},
	createReason({ rootState, state }, reason) {
		return axios
			.post("/api/supplier/CreateReason", {
				supplierId: rootState.user.account.supplierId,
				Reason: {
					description: reason.description,
					ReasonType: reason.reasonType,
				},
			})
			.then((response) => {
				if (response && response.status === 200) {
					state.reasons.push(response.data);
					return true;
				}
				return false;
			})
			.catch(function () {
				return false;
			});
	},
	setSelectedReason({ state }, reason) {
		state.selectedReason = reason;
	},
	updateReason({ rootState, commit }, reason) {
		return axios
			.post("/api/supplier/EditReason", {
				supplierId: rootState.user.account.supplierId,
				Reason: {
					id: reason.id,
					description: reason.description,
					ReasonType: reason.reasonType,
				},
			})
			.then((response) => {
				if (response.status == 200) {
					commit("UPDATE_REASON", response.data);
					return true;
				}
				return false;
			});
	},
	deleteReason({ rootState, commit }, reason) {
		return axios
			.post("/api/supplier/DeleteReason", {
				supplierId: rootState.user.account.supplierId,
				Reason: {
					id: reason.id,
					description: reason.description,
					ReasonType: reason.reasonType,
				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data == true) {
						commit("REMOVE_REASON", reason);
					}
				}
			});
	},
	fetchCustomBusinessTypes({ commit, rootState, state, dispatch }) {
		return axios
			.get(
				`api/businessType/GetAllBusinessesTypeBySupplierId?supplierId=${rootState.user.account.supplierId}`
			)
			.then((response) => {
				if (response && response.status === 200 && response.data) {
					commit("INIT_CUSTOM_BUSINESS_TYPES", {
						customBusinessTypes: !!response.data ? response.data : [],
					});
					return true;
				}
				return false;
			})
			.catch(function () {
				return false;
			});
	},
	createCustomBusinessType({ rootState, state }, customBusinessType) {
		return axios
			.post("/api/businessType/CreateBusinessType", {
				id: customBusinessType.id,
				name: customBusinessType.name,
				description: customBusinessType.description,
				supplierId: rootState.user.account.supplierId,
			})
			.then((response) => {
				if (response && response.status === 200) {
					state.customBusinessTypes.push(response.data);
					return true;
				}
				return false;
			})
			.catch(function () {
				return false;
			});
	},
	setSelectedCustomBusinessType({ state }, customBusinessType) {
		state.selectedCustomBusinessType = customBusinessType;
	},
	updateCustomBusinessType({ rootState, state, commit }, customBusinessType) {
		return axios
			.post("/api/businessType/UpdateBusinessType", customBusinessType)
			.then((response) => {
				if (response.status == 200) {
					return true;
				}
				return false;
			});
	},
	deleteCustomBusinessType({ rootState, commit }, customBusinessType) {
		return axios
			.post(
				`/api/businessType/DeleteBusinessTypeById?businessId=${customBusinessType.id}&supplierId=${rootState.user.account.supplierId}`
			)
			.then((response) => {
				if (response.status == 200) {
					if (response.data == true) {
						commit("REMOVE_CUSTOM_BUSINESS_TYPE", customBusinessType);
					}
				}
			});
	},
	deleteReason({ rootState, commit }, reason) {
		return axios
			.post("/api/supplier/DeleteReason", {
				supplierId: rootState.user.account.supplierId,
				Reason: {
					id: reason.id,
					description: reason.description,
					ReasonType: reason.reasonType,
				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data == true) {
						commit("REMOVE_REASON", reason);
					}
				}
			});
	},
};

const mutations = {
	SET_CARD_SUBSCRIPTION: (state, data) => {
		state.selectedSubscription = data;
	},

	CLEAR_CARD_SUBSCRIPTION: (state) => {
		state.selectedSubscription = null;
	},

	SET_IS_LOADING_REASONS: (state, data) => {
		state.isLoadingReasons = data;
	},

	UPDATE_SUBSCRIBED_PLUGINS: (state, data) => {
		state.plugins = data.plugins;
	},

	UPDATE_SETTINGS_COMPANY: (state, data) => {
		state.settings = data;
		state.showSunriseSunset = data.isToShowSunriseAndSunsetOnCalendar || false;
	},

	GET_COMPANY_INFO: (state, data) => {
		state.company = data;
	},

	UPDATE_COMPANY: (state, data) => {
		state.company = data;
	},

	SET_SKIP_STARTING_TASKS: (state) => {
		state.skipStartingTasks = true;
	},

	SET_SUPPLIER_TIER: (state, payload) => {
		state.supplierTierInfo = payload;
	},
	
	SET_ALL_TIERS_OPTIONS: (state, payload) => {
		state.allTiersOptionsInfo = payload;
	},
	
	INIT_REASONS: (state, data) => {
		state.reasons = data.reasons;
	},
	INIT_CUSTOM_BUSINESS_TYPES: (state, data) => {
		state.customBusinessTypes = data.customBusinessTypes;
	},
	UPDATE_REASON: (state, payload) => {
		const index = state.reasons.indexOf(payload);
		const updatedReasons = [...state.reasons]; // Create a copy of the reasons array
		updatedReasons.splice(index, 1, payload); // Replace the reason at the found index with the new payload

		// Return a new state object with the updated reasons array
		return {
			...state,
			reasons: updatedReasons,
		};
	},
	REMOVE_REASON: (state, payload) => {
		let index = state.reasons.indexOf(payload);
		state.reasons.splice(index, 1);
	},
	REMOVE_CUSTOM_BUSINESS_TYPE: (state, payload) => {
		let index = state.customBusinessTypes.indexOf(payload);
		state.customBusinessTypes.splice(index, 1);
	},
	SHOW_SUNRISE_SUNSET: (state, flag) => {
		if (flag !== undefined) {
			state.company.isToShowSunsetSunrise = flag;
		} else {
			state.settings.isToShowSunriseAndSunsetOnCalendar = !state.showSunriseSunset;
		}
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js